<template>
    <div class="card p-3 bg-white mb-1">
        <div class="card-header">
            <h3>{{ index+1 }}. szerző</h3>
            <button class="x-icon-delete" @click.prevent="deleteHallgato" title="Hallgató törlése"></button>
            <button class="x-icon-up" :disabled="index == 0" @click.prevent="upHallgato" title="Hallgató feljebb csúsztatása"></button>
            <button class="x-icon-down" :disabled="index == palyamunka.temavezetok.length-1" @click.prevent="downHallgato" title="Hallgató lejjebb csúsztatása"></button>
        </div>
        <div class="card-body">
            <form>
                <div class="form-group mb-1">
                    <label for="nev">Vezetékneve</label>
                    <input type="text" id='nev' v-model.trim="hallgato.vezetekNev" class="form-control" title="A szerző vezetékneve" required>
                </div>
                <div class="form-group mb-1">
                    <label for="nev">Keresztneve</label>
                    <input type="text" id='nev' v-model.trim="hallgato.keresztNev" class="form-control" title="A szerző keresztneve" required>
                </div>
                <div class="form-group mb-1">
                    <label for="omAzon">Oktatási azonosító szám (amennyiben magyarországi felsőoktatási intézmény hallgatója)</label>
                    <input type="text" id='omAzon' v-model.trim="hallgato.omAzon" class="form-control" title="A szerző oktatási azonosító száma, amennyiben magyarországi felsőoktatási intézmény hallgatója">
                </div>
                <div class="form-group mb-1">
                    <label for="email">E-mail címe</label>
                    <input type="email" id='email' v-model.trim="hallgato.email" class="form-control" title="Hallgató e-mail címe (amit a hallgató várhatóan az OTDK nevezés és az OTDK idején is használni fog)" required @blur="hallgato.email = hallgato.email.toLowerCase()">
                </div>
                <div class="form-group mb-1">
                    <label for="szerzosegArany">Szerzőségi arány (százalékban)</label>
                    <input type="number" id='szerzosegiArany' v-model="hallgato.szerzosegiArany" class="form-control w-25" min="0" max="100" title="Több hallgató esetén a szerzőségi arány 1-100 között (az összes szerző esetén az összegnak 100-nak kell lennie). Egy hallgató, vagy egyenletes elosztás esetén elhagyható.">
                </div>
                <label for="szerzosegArany">Jogviszonyok<br/><i>Egy jogviszony felvétele kötelező, mert az igazolja a központi felhívásban foglaltaknak való megfelelést. További jogviszony megadása nem kötelező.</i></label>
                <div class="col-xs-2">
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault" v-model="hallgato.kozepiskolas">
                        <label class="form-check-label" for="flexSwitchCheckDefault">A szerző középiskolás a kari konferencia időpontjában</label>
                    </div>
                </div>
                <div class="form-group mb-1" v-if="hallgato.kozepiskolas">
                    <label for="kozepiskolaNev">Középiskola neve</label>
                    <input type="text" id='kozepiskolaNev' v-model.trim="hallgato.kozepiskolaiJogviszony.kozepiskolaNev" class="form-control" title="A szerző által látogatott középiskola neve" required>
                </div>
                <div class="form-group mb-1" v-if="hallgato.kozepiskolas">
                    <label for="kozepiskolaVaros">Középiskola városa</label>
                    <input type="text" id='kozepiskolaVaros' v-model.trim="hallgato.kozepiskolaiJogviszony.kozepiskolaVaros" class="form-control" title="A szerző által látogatott középiskola városa" required>
                </div>

                <div class="form-group clearfix" v-if="!hallgato.kozepiskolas">
                    <table v-if="hallgato.felsooktatasiJogviszonyok.length > 0" class="table">
                        <thead>
                            <tr>
                                <th scope="col">Intézmény</th>
                                <th scope="col">Kar</th>
                                <th scope="col">Aktív félévek</th>
                                <th scope="col">Típusa</th>
                                <th scope="col">Munkarendje</th>
                                <th scope="col">Megkezdés éve</th>
                                <th scope="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <jogviszony v-for="(jogviszony, index) in hallgato.felsooktatasiJogviszonyok" :index="index" :jogviszony="jogviszony" :hallgato="hallgato" />
                        </tbody>
                    </table>
                    <div class="text-center">
                        <button class="btn btn-secondary btn-sm float-sm-right" @click.prevent="addJogviszony">Felsőoktatási jogviszony felvétele</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import Jogviszony from './Jogviszony.vue'

export default {
   	components: {
		Jogviszony
	},
    props: ['hallgato', 'palyamunka', 'index'],
    methods: {
        deleteHallgato() {
            const index = this.palyamunka.szerzok.indexOf(this.hallgato);
            if (index > -1)
                this.palyamunka.szerzok.splice(index, 1);
        },
        upHallgato() {
            const index = this.palyamunka.szerzok.indexOf(this.hallgato);
            if (index > 0) {
                let tmp = this.palyamunka.szerzok[index-1];
                this.palyamunka.szerzok[index-1] = this.palyamunka.szerzok[index];
                this.palyamunka.szerzok[index] = tmp;
            }
        },
        downHallgato() {
            const index = this.palyamunka.szerzok.indexOf(this.hallgato);
            if (index < this.palyamunka.szerzok.length) {
                let tmp = this.palyamunka.szerzok[index+1];
                this.palyamunka.szerzok[index+1] = this.palyamunka.szerzok[index];
                this.palyamunka.szerzok[index] = tmp;
            }
        },
        addJogviszony() {
            this.$storage.createJogviszony(this.hallgato);
        }
    }
}
</script>
